import { useEffect, useRef, useState } from 'react';

interface QuestionnaireNavProps {
  onReset: () => void;
  onPrev: () => void;
  canPrev: boolean;
}

const helpItems = [
  '按最近两周的真实感受填,不用想太多',
  '检查报告那页,数据不清楚的就留空',
  '填完 5-8 分钟,中途不用保存,不会丢',
  '提交后郡主会看到你的完整内容',
];

export default function QuestionnaireNav({ onReset, onPrev, canPrev }: QuestionnaireNavProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <>
      <nav className="sticky top-0 z-50 bg-background-100/95 backdrop-blur-md border-b border-secondary-200/60">
        <div className="max-w-xl mx-auto px-4 h-12 flex items-center justify-between">
          <button
            type="button"
            onClick={() => {
              onReset();
              setMenuOpen(false);
            }}
            title="退出并重新填写"
            className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 border border-secondary-200 text-foreground-600 hover:text-primary-600 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
          <span className="text-sm font-medium text-foreground-800">问诊专业版</span>
          <div ref={wrapRef} className="relative">
            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 border border-secondary-200 text-foreground-600 hover:text-primary-600 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <i className="ri-more-2-fill text-lg"></i>
            </button>
            {menuOpen ? (
              <div className="absolute right-0 top-full mt-2 w-40 bg-background-50 rounded-xl border border-secondary-200 shadow-lg shadow-foreground-950/5 py-1.5">
                <button
                  type="button"
                  onClick={() => {
                    setHelpOpen(true);
                    setMenuOpen(false);
                  }}
                  className="w-full px-3.5 py-2 text-left text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-question-line"></i>填写说明
                </button>
                <button
                  type="button"
                  onClick={() => {
                    onPrev();
                    setMenuOpen(false);
                  }}
                  disabled={!canPrev}
                  className="w-full px-3.5 py-2 text-left text-sm transition-colors flex items-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-primary-50 hover:text-primary-600 text-foreground-700 cursor-pointer"
                >
                  <i className="ri-arrow-left-line"></i>上一步
                </button>
                <button
                  type="button"
                  onClick={() => {
                    onReset();
                    setMenuOpen(false);
                  }}
                  className="w-full px-3.5 py-2 text-left text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-refresh-line"></i>重新填写
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </nav>

      {helpOpen ? (
        <div className="fixed inset-0 z-[60] flex items-center justify-center px-5">
          <button
            type="button"
            aria-label="关闭说明"
            onClick={() => setHelpOpen(false)}
            className="absolute inset-0 bg-foreground-950/45 backdrop-blur-sm cursor-pointer"
          />
          <div className="relative w-full max-w-sm bg-background-50 rounded-2xl border border-secondary-200 p-5 shadow-xl">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-base font-semibold text-primary-600 font-heading">填写说明</h3>
              <button
                type="button"
                onClick={() => setHelpOpen(false)}
                className="w-7 h-7 flex items-center justify-center rounded-full text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-close-line"></i>
              </button>
            </div>
            <ul className="space-y-2.5">
              {helpItems.map((item) => (
                <li key={item} className="flex gap-2 text-sm text-foreground-700 leading-relaxed">
                  <i className="ri-checkbox-circle-fill text-primary-400 text-base shrink-0 mt-0.5"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <button
              type="button"
              onClick={() => setHelpOpen(false)}
              className="mt-4 w-full py-2.5 rounded-xl bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              知道了,继续填
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
}